export default __webpack_public_path__ + "static/media/disponibilidad inmediata.71c0f264.svg";